import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';    
//page links  
export default function Createjobtask() {
  return (
    <div className="container_roots">
  
  <Helmet>
  <title>EditorTask - India`s Trusted Platform for Jobs & Creative Talent</title>

  <meta name="description" content="Explore freelance opportunities, post job tasks, or showcase your creative work on EditorTask. Connecting job seekers and employers across India."/>
  <meta name="keywords" content="job portal, freelance jobs, editor showcase, hire editors, post jobs, portfolio platform, task marketplace, India jobs, design gigs, video editing work"/>
  <meta name="author" content="editortask.com" />
  <meta name="robots" content="index, follow" />

  <meta property="og:title" content="EditorTask - India’s Trusted Platform for Jobs & Creative Talent"/>
  <meta property="og:description" content="Find talent or your next opportunity on EditorTask. Post tasks, showcase creative work, and hire skilled editors and freelancers."/>
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.editortask.com/" />
  <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
  
</Helmet>

      <div className="container_size">
      <h1 className="contact-title">create-job-task</h1>
      </div>
</div>
    );
}
